import { render, staticRenderFns } from "./addDic.vue?vue&type=template&id=9ef9fa94&scoped=true&"
import script from "./addDic.vue?vue&type=script&lang=js&"
export * from "./addDic.vue?vue&type=script&lang=js&"
import style0 from "./addDic.vue?vue&type=style&index=0&id=9ef9fa94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef9fa94",
  null
  
)

export default component.exports